<template>
  <v-container id="kpis-aderencias-bdgd-historico" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card color="primary" icon="mdi-file-compare" inline class="ml-0 px-5 py-4">
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">KPIs Aderências BDGD</div>
          </template>

          <v-btn
            id="btn-novo-calculo-kpis-aderencias-bdgd"
            color="success"
            dark
            elevation="1"
            class="mt-5"
            style="float: left"
            relative
            text
            medium
            @click="$router.push('add')"
          >
            <v-icon left size="30px">mdi-plus-circle</v-icon>
            Novo cálculo
          </v-btn>

          <v-text-field
            id="kpis-aderencias-bdgd-historico-search"
            v-model="search"
            append-icon="mdi-magnify"
            class="break-search bs-kpis-aderencia ml-auto mt-4"
            label="Procurar"
            hide-details
            single-line
            style="max-width: 250px"
          />

          <general-progress-bars class="mt-11" :items="downloadProgressData" prefix-text="Baixando memórias de cálculo" />

          <v-divider class="mt-10" />

          <v-data-table
            class="kpis-aderencias-bdgd-table"
            :headers="headers"
            :items="kpis"
            :search.sync="search"
            :header-props="{
              sortByText: 'Ordenar Por'
            }"
            :footer-props="{
              itemsPerPageText: 'Itens por Página'
            }"
            no-data-text="Nenhum cálculo de KPIs disponível"
            no-results-text="Nenhum registro correspondente encontrado"
            mobile-breakpoint="800"
          >
            <template v-slot:[`item.id`]="{ item }">
              {{ item.id }}
            </template>
            <template v-slot:[`item.nome`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div class="text-truncate-column" v-bind="attrs" v-on="on">
                    {{ item.nome }}
                  </div>
                </template>
                <span>{{ item.nome }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.ano`]="{ item }">
              {{ item.ano }}
            </template>
            <template v-slot:[`item.usuario`]="{ item }">
              {{ item.usuario }}
            </template>
            <template v-slot:[`item.executed`]="{ item }">
              {{ item.executed }}
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <general-status :status="item.status" />
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                id="action-download-kpis-aderencias-bdgd"
                :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
                :disabled="item.status != 'SUCESSO'"
                color="gray"
                min-width="0"
                class="px-1"
                fab
                icon
                x-small
                :loading="downloadProgressData[item.id] !== undefined ? true : false"
                @click="baixarPlanilhaCalculo(item)"
              >
                <v-icon small>mdi-download</v-icon>
              </v-btn>
              <v-menu v-if="item.status == 'SUCESSO' || canRunItem(item) || canDeleteItem(item)" offset-y right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    id="action-more-kpis-aderencias-bdgd"
                    color="white"
                    class="ml-1 px-1"
                    height="22px"
                    width="22px"
                    fab
                    x-small
                    elevation="1"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-if="item.status == 'SUCESSO'" @click="$router.push(`graficos/${item.id}`)">
                    <v-list-item-icon class="mx-0 my-0 py-4">
                      <v-icon small>mdi-chart-box</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Visualizar Gráficos</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="canRunItem(item)" @click="executarCalculo(item.id)">
                    <v-list-item-icon class="mx-0 my-0 py-4">
                      <v-icon small>mdi-play</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Executar</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="canDeleteItem(item)" @click="openDeleteDialog(item)">
                    <v-list-item-icon class="mx-0 my-0 py-4">
                      <v-icon small>mdi-trash-can-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Deletar</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:[`footer`]>
              <v-switch
                v-if="$store.getters.userIsAdmin"
                class="pa-0 pl-2 swithInterna"
                style="position: absolute"
                color="primary"
                label="Exibir Expirados"
                dense
                @change="((processamentosExpirados = $event), getAllKpis())"
              />
            </template>
          </v-data-table>
        </base-material-card>
        <dialog-delete
          :show-dialog="dialogDelete"
          @changeValue="dialogDelete = $event"
          @deleteTriggered="deletarCalculo(dialogDeleteData.id)"
        >
          <template slot="title">Deletar cálculo #{{ dialogDeleteData.id }}</template>
          <template slot="body">
            Tem certeza que deseja deletar
            <strong>{{ dialogDeleteData.nome }}</strong>
            ?
          </template>
        </dialog-delete>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import KpisAderenciasBdgdService from '@/services/KpisAderenciasBdgdService';
  import tourMixins from '@/mixins/tourMixins';
  import dayjs from 'dayjs';
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';
  import pusherMixins from '@/mixins/pusherMixins';

  export default {
    components: {
      DialogDelete: () => import('@/components/general/DialogDelete'),
      GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue')
    },
    mixins: [powerupsActionsMixins, pusherMixins, tourMixins],
    data() {
      return {
        headers: [
          {
            text: '#',
            value: 'id'
          },
          {
            text: 'Nome',
            value: 'nome'
          },
          {
            text: 'Ano',
            value: 'ano'
          },
          {
            text: 'Usuário',
            value: 'usuario'
          },
          {
            text: 'Executado',
            value: 'executed'
          },
          {
            text: 'Status',
            value: 'status'
          },
          {
            sortable: false,
            text: 'Ações',
            value: 'actions',
            class: 'pl-4'
          }
        ],
        arrTour: [
          {
            element: '#btn-novo-calculo-kpis-aderencias-bdgd',
            intro: 'Clicando neste botão você poderá criar novos cálculos de KPIs de Aderências de BDGD.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#kpis-aderencias-bdgd-historico-search',
            intro: 'Neste campo você poderá pesquisar por cálculos já existentes.',
            scrollTo: 'tooltip',
            position: 'bottom'
          },
          {
            element: '#action-download-kpis-aderencias-bdgd',
            intro: 'Clicando neste ícone você poderá fazer o download em .XLSX das memórias de cálculos.',
            scrollTo: 'tooltip',
            position: 'left'
          },
          {
            element: '#action-more-kpis-aderencias-bdgd',
            intro:
              'Aqui você acessa outras opções relacionadas ao cálculo, como visualizar gráficos, executá-lo novamente ou deletá-lo.',
            scrollTo: 'tooltip',
            position: 'left'
          }
        ],
        kpis: [],
        search: '',
        downloadProgressData: {},
        dialogDelete: false,
        processamentosExpirados: false,
        dialogDeleteData: { id: undefined, nome: undefined }
      };
    },
    computed: {
      user() {
        return this.$store.getters.getUser;
      }
    },
    mounted() {
      this.subscribe();
      this.getAllKpis();
    },
    methods: {
      subscribe() {
        this.pusherChannel.bind('refreshKpisAderenciasBdgd', () => {
          this.getAllKpis();
        });
      },
      getAllKpis() {
        KpisAderenciasBdgdService.getAllKpis(this.processamentosExpirados)
          .then((response) => {
            const kpis = [];
            response.data.kpis.forEach((val) => {
              kpis.push({
                id: val.id,
                nome: val.nome,
                usuario: val.usuario.nome,
                usuario_id: val.usuario.id,
                ano: val.ano,
                executed: val.executado_em ? dayjs(val.executado_em).format('DD/MM/YYYY HH:mm') : '-',
                status: val.status
              });
            });
            this.kpis = kpis;
          })
          .catch((err) => {
            console.log('Erro: ', err);
            this.$toast.error('Ocorreu um erro ao carregar os relatórios de KPIs', '', { position: 'topRight' });
          })
          .finally(() => this.iniciarTourPagina());
      },
      iniciarTourPagina() {
        if (this.tourFuncCalled) return;
        let arrTourFormatted = this.kpis.length ? this.arrTour : this.arrTour.splice(0, 2);
        this.iniciarTour(arrTourFormatted);
      },
      openDeleteDialog(calculo) {
        this.dialogDeleteData = {
          id: calculo.id,
          nome: calculo.nome
        };
        this.dialogDelete = true;
      },
      deletarCalculo(id) {
        this.dialogDelete = false;
        KpisAderenciasBdgdService.excluir(id)
          .then(() => {
            this.getAllKpis();
            this.$toast.success('Cálculo excluído com sucesso.', '', {
              position: 'topRight'
            });
          })
          .catch((err) => {
            this.$toast.error('Ocorreu um erro ao excluir o cálculo.', '', {
              position: 'topRight'
            });
            console.log('Erro: ', err);
          });
      },
      executarCalculo(id) {
        KpisAderenciasBdgdService.executar(id)
          .then(() => {
            this.$toast.info('Seu cálculo será gerado em instantes. Por favor, aguarde.', '', {
              position: 'topRight',
              timeout: 2000
            });
            this.getAllKpis();
          })
          .catch((err) => {
            this.$toast.error('Ocorreu um rrro ao executar o cálculo.', '', {
              position: 'topRight'
            });
            console.log('Erro: ', err);
          });
      },
      baixarPlanilhaCalculo(item) {
        const { id, nome } = item;
        const nomeArquivo = `Resultado_KPIs_Aderencias_Bdgd_${id}_${nome}.xlsx`;

        this.$set(this.downloadProgressData, id, { id });
        this.$toast.info('Preparando seu arquivo para download.', '', {
          position: 'topRight',
          timeout: 2000
        });

        KpisAderenciasBdgdService.baixar(id, {
          onDownloadProgress: (progressEvent) => {
            let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            let isComputable = progressEvent.lengthComputable;
            this.$set(this.downloadProgressData, id, {
              progress,
              isComputable,
              id
            });
          }
        })
          .then(async (res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nomeArquivo);
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => {
            this.$toast.error('Falha no download do resultado.', '', {
              position: 'topRight'
            });
            console.log('Erro: ', err);
          })
          .finally(() => {
            this.$delete(this.downloadProgressData, id);
          });
      }
    }
  };
</script>

<style>
  @media screen and (min-width: 800px) {
    .kpis-aderencias-bdgd-table table tr td:nth-child(2) {
      max-width: 200px;
    }

    .kpis-aderencias-bdgd-table table tr td:nth-child(6),
    .kpis-aderencias-bdgd-table table tr td:nth-child(7) {
      white-space: nowrap !important;
    }
  }

  @media screen and (max-width: 480px) {
    .bs-kpis-aderencia {
      width: 182.77px !important;
    }
  }

  .swithInterna label {
    font-size: 13px !important;
    margin-left: 0px !important;
  }
</style>